var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0607 21.0607C31.6464 20.4749 31.6464 19.5251 31.0607 18.9393L21.5147 9.3934C20.9289 8.80761 19.9792 8.80761 19.3934 9.3934C18.8076 9.97919 18.8076 10.9289 19.3934 11.5147L27.8787 20L19.3934 28.4853C18.8076 29.0711 18.8076 30.0208 19.3934 30.6066C19.9792 31.1924 20.9289 31.1924 21.5147 30.6066L31.0607 21.0607ZM10 21.5H30V18.5H10V21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.aa2c23b06812dac76be6a72f4a462cbd.svg";
export { ForwardRef as ReactComponent };